import BreadCrumb from "components/Common/BreadCrumb";
import CollapseFilter from "components/Common/CollapseFilter";
import CopyWrapper from "components/Common/CopyWrapper";
import DatePickerCustom from "components/Common/DatePickerCustom";
import LabelWrapper from "components/Common/LabelWrapper";
import TableContainer from "components/Common/TableContainer";
import { useRole } from "components/Hooks/UserHooks";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { COLOR_ADULT_VERIFY_STATUS, COLOR_RESERVATION_USER_TYPE, LIST_ADULT_VERIFY_PROVIDER_OPTION, LIST_ADULT_VERIFY_STATUS_OPTION, LIST_OPTION_GENDER, RESERVATION_USER_TYPE } from "helpers/constans";
import {
  formatDateStringToKorea,
  formatDateStringToUTC,
} from "helpers/format";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  BooleanParam,
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import { useSelector } from "react-redux";
import CountUp from "react-countup";
import NO_IMAGE_USER from "../../assets/images/no-user.png";
import ModalPreview from "components/Common/ModalPreview";
import ModalMultiPreviewImage from "components/Common/ModalMultiPreviewImage";
import { getAdultVerifyLogs } from "store/adult-verify-log/thunk";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import DropdownAsyncUsers from "components/Common/DropdownAsyncUsers";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import DatePicker from "react-datepicker";
import { PatternFormat } from 'react-number-format';
import { getPhoneFormat } from "components/Common/PhoneInput";

const TYPE_SELECT_DEFAULT: string = "created_at";
registerLocale("en", en);
registerLocale("ko", ko);

const LIST_OPTION_GENDER_FORMAT = LIST_OPTION_GENDER.filter((item) => item?.value !== "ANY");

const AdultVerifyLogList = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    name: withDefault(StringParam, ""),
    phoneNumber: withDefault(StringParam, ""),
    dateOfBirth: withDefault(StringParam, ""),
    gender: withDefault(StringParam, ""),
    provider: withDefault(StringParam, ""),
    userIds: withDefault(StringParam, ""),
    isSuccess: withDefault(StringParam, ""),
    startDate: withDefault(StringParam, ""),
    endDate: withDefault(StringParam, ""),
  });

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.startDate
      ? moment(query?.startDate || "", "Y-MM-DD").toDate()
      : null,
    query?.endDate ? moment(query?.endDate || "", "Y-MM-DD").toDate() : null,
  ]);
  const [startDate, endDate] = dateSearch;


  const [nameSearch, setNameSearch] = useState<string>(query?.name || "");
  const [phoneNumberSearch, setPhoneNumberSearch] = useState<string>(query?.phoneNumber || "");
  const [birthDaySearch, setBirthDaySearch] = useState<any>(query?.dateOfBirth
    ? moment(query?.dateOfBirth || "", "Y-MM-DD").toDate()
    : null);
  const [genderSearch, setGenderSearch] = useState<string>(query?.gender || "");
  const [providerSearch, setProviderSearch] = useState<string>(query?.provider || "");
  const [userIdSearch, setUserIdSearch] = useState<any>(query?.userIds || "");
  const [statusSearch, setStatusSearch] = useState<any>(
    LIST_ADULT_VERIFY_STATUS_OPTION?.find((item) => item?.value === (query?.isSuccess === true ? 1 : (query?.isSuccess === false ? 0 : "")))
      ?.value || ""
  );

  const [linkImage, setLinkImage] = useState<any>(null);

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.AdultVerifyLog;

  const AdultVerifyLogProperties = createSelector(
    selectLayoutState,
    (state) => ({
      adultVerifyLogs: state?.adultVerifyLogs,
      isAdultVerifyLogLoading: state?.isAdultVerifyLogLoading,
      isAdultVerifyLogSuccess: state?.isAdultVerifyLogSuccess,
      error: state?.error,
    })
  );

  const { adultVerifyLogs, isAdultVerifyLogLoading } = useSelector(
    AdultVerifyLogProperties
  );

  function loadTableData() {
    dispatch(getAdultVerifyLogs(query));
  }

  const searchData = () => {
    setQuery({
      ...query,
      name: nameSearch || "",
      phoneNumber: (phoneNumberSearch || "").replace(/-/g, "") || "",
      dateOfBirth: birthDaySearch ? moment(birthDaySearch).format("YMMDD") : "",
      gender: genderSearch || "",
      provider: providerSearch || "",
      userIds: userIdSearch?.value !== "all" ? userIdSearch?.value : "",
      isSuccess: statusSearch === 1 ? true : (statusSearch === 0 ? false : null),
      startDate: startDate
        ? formatDateStringToUTC(
          moment(new Date(startDate))
            .startOf("day")
            .format("Y-MM-DD HH:mm:ss")
        )
        : "",
      endDate: endDate
        ? formatDateStringToUTC(
          moment(new Date(endDate)).endOf("day").format("Y-MM-DD HH:mm:ss")
        )
        : "",
      sortBy: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        name: "",
        phoneNumber: "",
        dateOfBirth: "",
        mobileCarrier: "",
        gender: "",
        provider: "",
        userIds: "",
        isSuccess: "",
        startDate: "",
        endDate: "",
        sortBy: TYPE_SELECT_DEFAULT,
        time_request: +new Date(),
      },
      "push"
    );

    setNameSearch("");
    setPhoneNumberSearch("");
    setBirthDaySearch("");
    setGenderSearch("");
    setProviderSearch("");
    setStatusSearch("");
    setUserIdSearch("");
    setDateSearch([null, null]);
  };

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  // End::Change isSuccess

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 60,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div style={{ width: 35 }}>
              {adultVerifyLogs?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Provider"),
        accessor: "provider",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const provider = cell?.value;
          return (
            <div className="" style={{ minWidth: 80 }}>
              {t(
                LIST_ADULT_VERIFY_PROVIDER_OPTION?.find(
                  (item: any) => (item?.value) == (provider)
                )?.label || ""
              )}
            </div>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "isSuccess",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const isSuccess = cell?.value ? 1 : 0;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_ADULT_VERIFY_STATUS[isSuccess] || "secondary"
                  }`}
              >
                {t(
                  LIST_ADULT_VERIFY_STATUS_OPTION?.find(
                    (item: any) => (item?.value) == (isSuccess)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Name"),
        accessor: "name",
        filterable: true,
        sortable: false,
        thWidth: 180,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            cell?.value ? (
              <div className="cursor-pointer" style={{ width: "135px" }}>
                <CopyWrapper contentCopy={cell?.value}>
                  {`${cell?.value}`}
                </CopyWrapper>
              </div>
            ) : "-"
          );
        },
      },
      {
        Header: t("Phone Number"),
        accessor: "phoneNumber",
        filterable: true,
        sortable: false,
        thWidth: 180,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const { format } = getPhoneFormat(cell?.value);
          return (
            cell?.value ? (
              <div className="cursor-pointer" style={{ width: "135px" }}>
                <CopyWrapper contentCopy={cell?.value}>
                  <PatternFormat
                    value={cell?.value}
                    displayType="text"
                    format={format}
                  />
                </CopyWrapper>
              </div>
            ) : "-"
          );
        },
      },
      {
        Header: t("Birthday"),
        accessor: "dateOfBirth",
        filterable: false,
        sortable: false,
        thWidth: 160,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const date = moment(cell?.value).format("YYYY-MM-DD");

          return (
            <CopyWrapper contentCopy={date}>
              <span>{date || ""}</span>
            </CopyWrapper>
          );
        },
      },
      {
        Header: t("Gender"),
        accessor: "gender",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 100,
        Cell: (cell: any) => {
          return <div className="cursor-pointer">
            {t(
              LIST_OPTION_GENDER_FORMAT.find((i) => i.value == cell?.value)
                ?.label || "-"
            )}
          </div>;
        },
      },
      {
        Header: t("User Info"),
        accessor: "user",
        filterable: false,
        sortable: false,
        thWidth: 260,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const user: any = cell?.row?.original?.user;
          const userType: any = user?.type;
          let avatar = user?.profile?.imageUrls?.[0] || "";
          let nickname = user?.profile?.nickname || "";
          let email = user?.profile?.email || "";
          const images = user?.profile?.imageUrls;

          if (userType === "MANAGER") {
            avatar = user?.store?.thumbnailUrl;
            nickname = user?.store?.managerName;
            email = user?.store?.managerEmail || "";
          }

          return (
            <div
              className="d-flex align-items-center gap-2"
            >
              <div
                className="cursor-pointer overflow-hidden object-fit-cover"
                style={{
                  height: "45px",
                  width: "45px",
                  minWidth: "45px",
                }}
                onClick={() => setLinkImage((images?.length > 1 && userType === "APPLICANT") ? { urls: images } : { url: avatar })}
              >
                <img
                  className="overflow-hidden object-fit-cover rounded-circle"
                  src={avatar || NO_IMAGE_USER}
                  alt={nickname}
                  height={45}
                  width={45}
                  style={{
                    minWidth: "45px",
                  }}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = NO_IMAGE_USER;
                  }}
                />
              </div>
              {(
                <div>
                  <div className="fw-semibold">
                    <span
                      className={`rounded-pill badge bg-${COLOR_RESERVATION_USER_TYPE[userType] || "secondary"
                        }`}
                    >
                      {t(
                        RESERVATION_USER_TYPE?.find(
                          (item: any) => String(item?.value) === String(userType)
                        )?.label || ""
                      )}
                    </span>
                  </div>

                  <div className="d-flex flex-column">
                    {
                      ((userType === "MANAGER" && !user?.store) || (userType === "APPLICANT" && !user?.profile)) ? (
                        <>
                          {
                            user?.email ? (
                              <div><small>{t("Email SNS")}:</small> {user?.email}</div>
                            ) : (
                              <>
                                <div className="cursor-pointer">
                                  {user?.providerId}
                                </div>
                              </>
                            )
                          }
                        </>
                      ) : (
                        <>
                          <span>
                            {nickname || "-"}
                          </span>
                          <small className="text-secondary">
                            {email || `${t("Email SNS")}: ${user?.email} `}
                          </small>
                        </>
                      )
                    }
                  </div>
                </div>
              )}
            </div>
          );
        },
      },
      {
        Header: t("Verify Date"),
        accessor: "createdAt",
        filterable: false,
        sortable: false,
        thWidth: 120,
        thClass: "whitespace-nowrap text-end",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value || "");
          const arrDatePublish = String(date || "").split(" ");

          return (
            <div className="text-end">
              <span>
                <span>{arrDatePublish?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">
                  {arrDatePublish?.[1] || "-"}
                </span>{" "}
              </span>
            </div>
          );
        },
      },
    ],
    [i18n?.language, adultVerifyLogs?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
  }, []);

  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  useEffect(() => {
    loadTableData();
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    document.title = `${t("Adult Verify Log")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  const [formatPhoneNumberSearch, setFormatPhoneNumberSearch] = useState('###-####-####');

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Adult Verify Log")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-5 con-sm-6">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={adultVerifyLogs?.pagination?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          isShow={!!nameSearch}
                          label={`${t("Name")}`}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Name")}...`}
                            value={nameSearch}
                            onChange={(e) =>
                              setNameSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          isShow={!!phoneNumberSearch}
                          label={`${t("Phone Number")}`}
                        >
                          <PatternFormat
                            className={'form-control search'}
                            placeholder={'Phone Number'}
                            value={phoneNumberSearch || ''}
                            format={formatPhoneNumberSearch}
                            onValueChange={(values: { value: string; formattedValue: string }) => {
                              const { value } = values;
                              const digits = value.replace(/\D/g, '');

                              if (digits.length >= 2) {
                                const { format: newFormat } = getPhoneFormat(digits);
                                setFormatPhoneNumberSearch(newFormat);
                              }
                              setPhoneNumberSearch(value)
                            }
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />

                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2 adult-verify date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          isShow={!!birthDaySearch}
                          label={`${t("Birthday")}`}
                        >
                          <DatePicker
                            name={"dateOfBirth"}
                            className="form-control w-full"
                            selected={birthDaySearch ?? null}
                            placeholderText={`${t("Input/ Choose Birthday")}...`}
                            onChange={(date: any) => {
                              setBirthDaySearch(date)
                            }}
                            dateFormat="yyyy-MM-dd"
                            isClearable={!!birthDaySearch}
                          />

                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Gender")} isShow={true}>
                          <DropdownOptionNew
                            name="required-gender"
                            dataList={LIST_OPTION_GENDER_FORMAT || []}
                            placeholder={`${t("Gender")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={genderSearch}
                            onChangeSelect={(e: any) =>
                              setGenderSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Provider")} isShow={true}>
                          <DropdownOptionNew
                            name="provider"
                            dataList={LIST_ADULT_VERIFY_PROVIDER_OPTION || []}
                            placeholder={`${t("Provider")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={providerSearch}
                            onChangeSelect={(e: any) =>
                              setProviderSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("User")} isShow={true}>
                          <DropdownAsyncUsers
                            name="user"
                            onChangeSelect={(event: any) => {
                              setUserIdSearch(event);
                            }}
                            isMulti={false}
                            placeholder={`${t("Select User")}...`}
                            isShowIconCheck={false}
                            isAllOption={true}
                            listCheckedUsers={userIdSearch}
                            defaultParams={{
                              isReal: 1,
                              isAgeVerified: true
                            }}
                            isClearable={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={LIST_ADULT_VERIFY_STATUS_OPTION || []}
                            placeholder={`${t("Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) =>
                              setStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_ADULT_VERIFY_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-3 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!startDate || !!endDate}
                        >
                          <DatePickerCustom
                            startDate={startDate || null}
                            endDate={endDate || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col
                        sm={12}
                        md={12}
                        xl={12}
                        xxl={12}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed sticky-table-resume-view-log-list"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={
                        adultVerifyLogs?.items?.length
                          ? adultVerifyLogs?.items
                          : []
                      }
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={adultVerifyLogs?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(adultVerifyLogs?.pagination?.total) /
                        Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sortBy: query.sortBy,
                        orderBy: query.orderBy,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isAdultVerifyLogLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ModalPreview
          type={"IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreviewImage
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          onClose={() => onCloseImageClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default AdultVerifyLogList;
